import { typographyV2 } from '@toggle/design-system';
import { PriceStatus } from '@toggle/helpers';
import styled from 'styled-components';

import { priceChangeColors } from '~/utils/common/utils';

export const AssetWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 28px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const SubtitleLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const AssetTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChangeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const ChangeValue = styled.span<{ $status: PriceStatus }>`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodySm};
  color: ${({ $status }) => priceChangeColors[$status]};
`;

export const InsightsContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const InsightCount = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledSkeletonLoaderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Root = styled.div`
  th:nth-last-child(2),
  td:nth-last-child(2) {
    width: 1%;

    * {
      white-space: nowrap;
    }
  }
`;

export const Placeholder = styled.div`
  width: 20px;
  height: 20px;
`;
